import { render, staticRenderFns } from "./LmPassenger.vue?vue&type=template&id=73c33833"
import script from "./LmPassenger.vue?vue&type=script&lang=js"
export * from "./LmPassenger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports